import { QueryOptions } from "../components/Common/useQuery";
import useUserOrEmployeeQuery from "../components/Common/useUserOrEmployeeQuery";
import { useUserOrKaEmployee } from "../components/UserAccess/useUserOrKaEmployee";

export interface ApplicatorDto {
  id: string;
  name: string;
  license?: string;
  epaNumber?: string;
  emailAddresses: string[];
}

const useGetApplicators = (options?: QueryOptions<ApplicatorDto[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();

  return useUserOrEmployeeQuery<ApplicatorDto[]>(
    { path: `/api/businesses/${selectedBusiness?.id}/applicators` },
    options);
}

export default useGetApplicators;